import React from "react";
import PropTypes from "prop-types";
import { Space, Table, Popconfirm, Button, Input } from "antd";
import { connect } from "react-redux";
import { Controller } from "react-hook-form";
import { HomePageTable } from "../Common";
import { tableStringSorter } from "../../utils/table";
import InputElement from "./ReportInputElement";
import { useTableColumnSearch } from "../../hooks/table.hook";
import {
  MONTHLY,
  QUARTERLY,
  WEEKLY,
  BIANNUALLY,
  YEARLY,
} from "../../utils/report";

const linkStyle = {
  padding: "4px",
};
const tableHeight =
  window.innerHeight - 530 > 800 ? window.innerHeight - 530 : 800;

export const getTableColumns = ({
  setRecord,
  selectedRecordId,
  deletePermission,
  type,
  isUpdating,
  isDeleting,
  deleteReportFn,
  getColumnSearchProps = () => ({}),
}) => {
  return [
    {
      title: "Report Name",
      dataIndex: "ReportName",
      fixed: "left",
      editable: false,
      width: "200px",
      sorter: tableStringSorter("ReportName"),
      ...getColumnSearchProps("ReportName"),
    },
    {
      title: "PMS Report Name",
      dataIndex: "PMSReportName",
      width: "250px",
      editable: true,
      sorter: tableStringSorter("PMSReportName"),
      ...getColumnSearchProps("PMSReportName"),
    },
    {
      title: "Report Frequency",
      dataIndex: "shedule_type",
      width: "200px",
      editable: false,
    },
    {
      title: "Report Category",
      dataIndex: "report_category",
      width: "200px",
      sorter: tableStringSorter("report_category"),
      ...getColumnSearchProps("report_category"),
      editable: true,
    },
    {
      title: "Signature Type",
      dataIndex: "signature_type",
      width: "200px",
      sorter: tableStringSorter("signature_type"),
      ...getColumnSearchProps("signature_type"),
      editable: true,
    },
    {
      title: "Report Order",
      dataIndex: "ReportOrder",
      width: "200px",
      editable: true,
      defaultSortOrder: "ascend",
      sorter: (a, b) =>
        (typeof a.ReportOrder !== "number" ? 99999999 : a.ReportOrder) -
        (typeof b.ReportOrder !== "number" ? 99999999 : b.ReportOrder),
      ...getColumnSearchProps("ReportOrder"),
    },
    {
      title: "Signature Mandatory",
      dataIndex: "SignatureMandatory",
      width: "250px",
      sorter: tableStringSorter("SignatureMandatory"),
      ...getColumnSearchProps("SignatureMandatory"),
      editable: true,
    },
    {
      title: "Smart Scan",
      dataIndex: "smart_scan_type",
      width: "200px",
      sorter: tableStringSorter("smart_scan_type"),
      ...getColumnSearchProps("smart_scan_type"),
      editable: true,
    },
    {
      title: "Generate Redact Files",
      dataIndex: "enable_redaction",
      width: "200px",
      editable: true,
    },
    {
      title: "Generate Flat Files",
      dataIndex: "export_flat_files",
      width: "200px",
      editable: true,
    },
    {
      title: "Split Reports By Sub Header Type",
      dataIndex: "split_by_sub_header",
      width: "200px",
      editable: true,
    },
    {
      title: "Document Type",
      dataIndex: "document_type",
      width: "300px",
      editable: true,
    },
    {
      title: "Submission Method",
      dataIndex: "SourceType",
      width: "200px",
      sorter: tableStringSorter("SourceType"),
      ...getColumnSearchProps("SourceType"),
      editable: true,
    },
    {
      title: "myDocs Report Type",
      dataIndex: "mydocs_report_type",
      width: "200px",
      sorter: tableStringSorter("mydocs_report_type"),
      ...getColumnSearchProps("mydocs_report_type"),
      editable: true,
    },
    ...([MONTHLY, QUARTERLY, BIANNUALLY, YEARLY].includes(type)
      ? [
          {
            title: "Schedule Type",
            dataIndex: "schedule_trigger_type",
            width: "150px",
            ...getColumnSearchProps("schedule_trigger_type"),
            editable: true,
          },
        ]
      : []),
    ...([WEEKLY, MONTHLY, QUARTERLY, YEARLY].includes(type)
      ? [
          {
            title: "Schedule",
            dataIndex: "schedule_weekday",
            key: "schedule_weekday",
            ...getColumnSearchProps("schedule_weekday"),
            width: "150px",
            editable: true,
          },
        ]
      : []),
    ...([BIANNUALLY].includes(type)
      ? [
          {
            title: "Schedule",
            dataIndex: "schedule_trigger_data",
            key: "schedule_trigger_data",
            ...getColumnSearchProps("schedule_trigger_data"),
            width: "150px",
            editable: true,
          },
        ]
      : []),
    ...([MONTHLY, QUARTERLY, YEARLY].includes(type)
      ? [
          {
            title: "Month",
            dataIndex: "schedule_months",
            key: "schedule_months",
            width: "150px",
            editable: true,
            sorter: tableStringSorter("schedule_months"),
            ...getColumnSearchProps("schedule_months"),
          },
        ]
      : []),
    {
      title: "Business Date",
      dataIndex: "business_date",
      width: "200px",
      ...getColumnSearchProps("business_date"),
      editable: true,
    },
    {
      title: "Subjects",
      dataIndex: "emailSubjects",
      width: "200px",
      editable: true,
      sorter: tableStringSorter("emailSubjects"),
      ...getColumnSearchProps("emailSubjects"),
      // ...this.getColumnSearchProps("emailSubjects", type),
    },
    {
      title: "File Names",
      dataIndex: "filenames",
      width: "200px",
      sorter: tableStringSorter("filenames"),
      ...getColumnSearchProps("filenames"),
      editable: true,
      // ...this.getColumnSearchProps("filenames", type),
    },
    {
      title: "File Extension",
      dataIndex: "FileExtension",
      width: "200px",
      sorter: tableStringSorter("FileExtension"),
      ...getColumnSearchProps("FileExtension"),
      editable: true,
      // ...this.getColumnSearchProps("FileExtension", type),
    },
    {
      title: "File Mapping Name",
      dataIndex: "FileMappingName",
      width: "200px",
      sorter: tableStringSorter("FileMappingName"),
      ...getColumnSearchProps("FileMappingName"),
      editable: true,
      // ...this.getColumnSearchProps("FileMappingName", type),
    },
    {
      title: "QC Ignored Report",
      dataIndex: "QC_IgnoredReport",
      width: "200px",
      sorter: tableStringSorter("QC_IgnoredReport"),
      ...getColumnSearchProps("QC_IgnoredReport"),
      editable: true,
    },
    {
      title: "Compliance",
      dataIndex: "ComplianceEnabled",
      width: "200px",
      sorter: tableStringSorter("ComplianceEnabled"),
      ...getColumnSearchProps("ComplianceEnabled"),
      editable: true,
    },
    {
      title: "Report Name Matching Condition",
      dataIndex: "report_name_matching_condition",
      width: "240px",
      ...getColumnSearchProps("report_name_matching_condition"),
      editable: true,
    },
    {
      title: "File Extension Mapping",
      dataIndex: "file_extension_mapping",
      width: "200px",
      ...getColumnSearchProps("file_extension_mapping"),
      editable: true,
    },
    {
      title: "Activation Date",
      dataIndex: "activation_date",
      width: "200px",
      ...getColumnSearchProps("activation_date"),
      editable: true,
    },
    {
      title: "Deactivation Date",
      dataIndex: "deactivation_date",
      width: "200px",
      ...getColumnSearchProps("deactivation_date"),
      editable: true,
    },
    {
      title: "Signature Activation Date",
      dataIndex: "signature_activation_date",
      width: "200px",
      ...getColumnSearchProps("signature_activation_date"),
      editable: true,
    },
    {
      title: "Signature Deactivation Date",
      dataIndex: "signature_deactivation_date",
      width: "200px",
      ...getColumnSearchProps("signature_deactivation_date"),
      editable: true,
    },
    {
      title: "Solution",
      dataIndex: "report_type",
      width: "200px",
      ...getColumnSearchProps("report_type"),
      editable: false,
    },
    {
      title: "Report ID",
      dataIndex: "_id",
      width: "200px",
      editable: false,
      ...getColumnSearchProps("_id"),
    },
    {
      title: "Created by",
      dataIndex: "create_by",
      width: "200px",
      ...getColumnSearchProps("create_by"),
      editable: false,
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      width: "200px",
      ...getColumnSearchProps("create_at"),
      editable: false,
    },
    {
      title: "Updated by",
      dataIndex: "update_by",
      width: "200px",
      ...getColumnSearchProps("update_by"),
      editable: false,
    },
    {
      title: "Updated at",
      dataIndex: "update_at",
      width: "200px",
      ...getColumnSearchProps("update_at"),
      editable: false,
    },
    {
      title: "Operation",
      dataIndex: "operation",
      fixed: "right",
      width: "180px",
      editable: false,
      render: (_text, record) => {
        const editable = selectedRecordId === record._id;
        return editable ? (
          <Space>
            {/* <Popconfirm
              title="Sure to cancel?"
              onConfirm={() => setRecord(null)}
            > */}
            <Button
              style={linkStyle}
              type="link"
              disabled={isUpdating || isDeleting}
              onClick={() => setRecord()}
            >
              Cancel
            </Button>
            {/* </Popconfirm> */}
            <Button
              style={linkStyle}
              htmlType="submit"
              type="link"
              loading={isUpdating}
              disabled={isDeleting}
            >
              Save
            </Button>
            {deletePermission ? (
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => deleteReportFn(record._id)}
                placement="topRight"
              >
                <Button
                  style={linkStyle}
                  type="link"
                  loading={isDeleting}
                  disabled={isUpdating}
                >
                  Delete
                </Button>
              </Popconfirm>
            ) : null}
          </Space>
        ) : (
          <Button
            style={linkStyle}
            disabled={selectedRecordId}
            onClick={() => setRecord(record._id)}
            type="link"
          >
            Edit
          </Button>
        );
      },
    },
  ];
};

const ViewPageTable = ({
  type,
  dataSource,
  setRecord,
  selectedRecordId,
  // userAccess,
  reportCategories,
  formParams,
  isUpdating,
  isDeleting,
  deletePermission,
  deleteReportFn,
  documentTypes,
}) => {
  const { control, errors, watch, setValue, getValues, resetField } =
    formParams;
  const { getColumnSearchProps } = useTableColumnSearch();

  const mergedColumns = getTableColumns({
    setRecord,
    selectedRecordId,
    deletePermission,
    type,
    isUpdating,
    isDeleting,
    deleteReportFn,
    getColumnSearchProps,
  }).map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: selectedRecordId === record._id,
      }),
    };
  });

  return (
    <HomePageTable>
      <Table
        components={{
          body: {
            cell: (props) => {
              const {
                // resetField,
                // watch,
                // setValue,
                // getValues,
                // reportCategories,
                // control,
                editing,
                // errors,
                dataIndex,
                record,
                index,
                children,
                ...restProps
              } = props;
              return (
                <td {...restProps}>
                {editing ? (
                  <Controller
                    control={control}
                    name={`report.${dataIndex}`}
                    render={({ field }) => (
                      // <Input {...field} />
                      <InputElement
                        field={field}
                        resetField={resetField}
                        watch={watch}
                        setValue={setValue}
                        getValues={getValues}
                        reportCategories={reportCategories}
                        errors={errors}
                        dataIndex={dataIndex}
                        formInputPath="report."
                        documentTypes={documentTypes}
                      />
                    )}
                  />
                ) : (
                  children
                )}
              </td>
              );
            },
          },
        }}
        columns={mergedColumns}
        dataSource={dataSource ?? []}
        rowKey="_id"
        pagination={{
          showTotal: (total) => `Total ${total} ${total === 1 ? "report" : "reports"}`,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
        scroll={{ x: 4200, y: tableHeight }}
      />
    </HomePageTable>
  );
};

ViewPageTable.propTypes = {};

const mapStateToProps = (state) => {
  return {
    deletePermission: state.api?.permission?.sm_report_delete,
  };
};

export default connect(mapStateToProps, null)(ViewPageTable);
